import { createReducer } from 'redux-create-reducer';
import { GLOBAL_LOADER_TOGGLE } from 'js/components/shared/constants';

const initialState = {
  isShow: false,
  activeLoaders: [],
};

export default createReducer(initialState, {
  [GLOBAL_LOADER_TOGGLE](state, action) {
    const { isShow, name } = action.payload;
    const currentLoaders = state.activeLoaders || [];

    let newLoaders;

    if (isShow) {
      if (currentLoaders.includes(name)) {
        return state;
      }
      newLoaders = [...currentLoaders, name];
    } else {
      newLoaders = currentLoaders.filter(loaderName => loaderName !== name);
    }

    return {
      ...state,
      activeLoaders: newLoaders,
      isShow: newLoaders.length > 0
    };
  },
})
